/** Refresh/transport ordering and mutation identity ownership have different lifetimes. */
let generation = 0;
let identityGeneration = 0;
export const authIdentityGeneration = () => identityGeneration;
export const isCurrentIdentity = (ticket: number) =>
  ticket === identityGeneration;
// Called for explicit transitions/loss, or an accepted refresh with a different user ID.
export function invalidateAuthIdentity() {
  return ++identityGeneration;
}
let transition: number | null = null;
export const authTransitionPending = () => transition !== null;
export const authGeneration = () => generation;
export const isCurrentAuth = (ticket: number) => ticket === generation;
export function invalidateAuth() {
  invalidateAuthIdentity();
  transition = null;
  return ++generation;
}
export function beginAuthTransition() {
  invalidateAuthIdentity();
  transition = ++generation;
  return transition;
}
export function finishAuthTransition(ticket: number) {
  if (transition === ticket) transition = null;
}
export function beginAuthRefresh() {
  // Order refresh responses without invalidating same-account mutations.
  // A focus event during login/logout must not read the previous cookie identity.
  return transition === null ? ++generation : null;
}
